// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "glycoforestwebapp-20181226143544--hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://glycoforestwebapp-20181226143544--hostingbucket-dev.s3-website-us-east-1.amazonaws.com",
    "aws_cognito_identity_pool_id": "us-east-1:47ca681d-e066-4597-b2c5-e2ec3e5c70b6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qmeHLsG7o",
    "aws_user_pools_web_client_id": "7vp9cvco24ph68i1nb36db7nar",
    "aws_appsync_graphqlEndpoint": "https://bik6gse57ze7ji7jk6xygsh3ie.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
